import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RoomDetails = _resolveComponent("RoomDetails")!
  const _component_Reviews = _resolveComponent("Reviews")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Room Details",
      subTitle: "Hotel"
    }),
    _createVNode(_component_RoomDetails),
    _createVNode(_component_Reviews)
  ]))
}